import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subscription } from 'rxjs';
import { Site } from 'src/app/model/site';
import { selectCurrentSite, selectSites } from 'src/app/store/site/site.selector';
import { UserFileService } from 'src/app/services/user-file.service';
import { User } from 'src/app/model/user';
import * as UserFileActions from 'src/app/store/user-file/user-file.actions';
import * as UserActions from 'src/app/store/user/user.actions';
import { StandardPageLayout } from '../../stdlayoutlib/classes.stdlayoutlib';

@Component({
	templateUrl: './site-selector.dialog.component.html',
})

export class SiteSelectorDialogComponent implements OnInit, OnDestroy {
	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;
	sites$: Observable<Site[] | undefined>;
	sitesSub: Subscription | undefined;

	sites: Site[];
	sitesOrder: Site[];

	site: Site;
	siteImage = { src: 'assets/images/tablet-bg.jpg' };
	technician: User;
	currentTechnician: User;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
		private userFileService: UserFileService,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.store.dispatch(UserFileActions.getSiteImages());
		this.store.dispatch(UserActions.getTechnicians());
		this.subscribeAll();
		this.onResize();
	}

	initSelectors(): void {
		this.site$ = this.store.select(selectCurrentSite);
		this.sites$ = this.store.select(selectSites);
	}

	subscribeAll(): void {
		this.siteSub = this.site$?.subscribe((site) => {
			this.site = site;
		});
		this.sitesSub = this.sites$?.subscribe(
			(sites) => {
				this.sites = sites;
				this.sitesOrder = this.orderSites(sites);
			}
		);
	}

	orderSites(sites: Site[]): Site[] {
		sites = sites.sort((a, b) => { return a.Name < b.Name ? -1 : 1 });
		return sites;
	}

	ngOnDestroy(): void {
		this.siteSub?.unsubscribe();
		this.sitesSub?.unsubscribe();
	}

	closeDialog() {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	onTablet(): boolean {
		return StandardPageLayout.onTablet(this.screenWidth);
	}

}
